import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Actions } from "./index";
import config from "constants/config";
import getCDNLink from "../../../../../constants/cdn-link";
import { PureFileIcon } from "../../dashboard/sections/payments";
import ClearFilters from "../../../../../components/table2/clear-filters";
import Pagination from "../../../../../components/pagination";


const MobileProducts = ({ data, clearFilters, showConfirm }) => {

    let SIZE = 3;
    const [currentPage, setCurrentPage] = useState(1);
    const currentTableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * SIZE;
        const lastPageIndex = firstPageIndex + SIZE;
        return data.slice(firstPageIndex, lastPageIndex);
    }, [currentPage, data]);

    if(!data.length) {
        if(clearFilters) {
            return <ClearFilters clearFilters={clearFilters} />
        }
        return null;
    }

    return (
        <div>
            {currentTableData.map((item, key) => {

                const { uniqid, type, stock, title, currency, price_display, price_variants, cloudflare_image_id } = item;

                let isInfo = type === "INFO_CARD";
                let isVariant = price_variants;

                return <div className="table-mobile-card" key={key}>

                    <div className="table-mobile-card-header">
                        <div className="d-flex">
                            <div className="table-mobile-card-header-icon">
                                {cloudflare_image_id ? <img src={getCDNLink({ id: cloudflare_image_id })} alt=""/> : <PureFileIcon />}
                            </div>

                            <div className="table-mobile-card-header-main">
                                <Link to={isInfo ? `/products/edit/info/${uniqid}` : isVariant ? `/products/edit/variant/${uniqid}` : `/products/edit/${uniqid}`}>{title}</Link>
                                <div>{uniqid}</div>
                            </div>
                        </div>
                        <Actions showConfirm={() => showConfirm(item)} data={item} />
                    </div>

                    <div className="table-mobile-card-body">
                        <div className="d-flex mr-2">
                            {type ? <div className={`mr-2 badge badge-paylixecommerce`}>{type.toLowerCase().replace("_", " ")}</div> : null}
                            <div>
                                {item.private ? <div className="badge badge-bad">Private</div> : null}
                                {item.on_hold ? <div className="badge badge-bad">On Hold</div> : null}
                                {item.unlisted ? <div className="badge badge-bad">Unlisted</div> : null}
                                {item.private || item.unlisted || item.on_hold ? null : item.linked ? <div className="badge badge-good" style={{ width: "fit-content" }}>Live</div> : <div style={{ width: "fit-content" }} className="badge badge-bad">Deleted</div>}
                            </div>
                        </div>
                        <div className="table-mobile-card-body-info">
                            {isInfo ? null : <div className="mr-3 text-nowrap">{type !== "INFO_CARD" ? stock === -1 ? <span style={{ marginRight: ".25rem", fontSize: 16 }}>∞</span> : stock : "-"} in stock</div>}
                            <div>{type === "INFO_CARD" || +price_display === 0 ? "Free" : <>{config.CURRENCY_LIST[currency]}{price_display}</>}</div>
                        </div>
                    </div>

                </div>
            })}

            <Pagination
                currentPage={currentPage}
                totalCount={data.length}
                pageSize={SIZE}
                onPageChange={setCurrentPage}
            />

        </div>
    );
};

export default MobileProducts;
